module.exports = {"500108001":"铜元局街道","500108002":"花园路街道","500108003":"南坪街道","500108004":"海棠溪街道","500108005":"龙门浩街道","500108006":"弹子石街道","500108007":"南山街道","500108008":"天文街道","500108101":"南坪镇","500108102":"涂山镇","500108103":"鸡冠石镇","500108105":"峡口镇","500108106":"长生桥镇","500108107":"迎龙镇","500108108":"广阳镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500108.json
// module id = 2219
// module chunks = 0